import { SocialUser } from 'angularx-social-login';
import { User } from 'rest-client';

import { PROVIDERS } from '@app/modules/core/utils/social-login.config';

import { SignUpForm } from '../models';

function setDefaultValues(
  signUpForm: SignUpForm,
  lang: string,
  user: User
): void {
  const {
    name,
    surname,
    email,
    password,
    acceptPromos,
    acceptNewsletter,
  } = signUpForm;

  user.name = name;
  user.lastName = surname;
  user.email = email;
  user.accept_promos = acceptPromos;
  user.accept_newsletter = acceptNewsletter;
  user.password = btoa(password);
  user.language = lang;
}

function setFacebookValues(user: User, socialUser: SocialUser): void {
  if (socialUser?.provider === PROVIDERS.facebook) {
    user.token_facebook = socialUser.authToken;
    user.auth_id_facebook = socialUser.id;
  }
}

function setGoogleValues(user: User, socialUser: SocialUser): void {
  if (socialUser?.provider === PROVIDERS.google) {
    user.auth_id_google = socialUser.id;
    user.token_google = socialUser.idToken;
  }
}

export function buildUser(
  signUpForm: SignUpForm,
  socialUser: SocialUser,
  lang: string
): User {
  const user = new User();

  setDefaultValues(signUpForm, lang, user);
  setFacebookValues(user, socialUser);
  setGoogleValues(user, socialUser);

  return user;
}
